import { v4 as uuid } from "uuid";

export const INIT_REQUEST_DATA = {
	reqApiName: "",
	reqApiUrl: "",
	reqMethod: "",
	reqAuth: {
		reqAuthUrl: "",
		reqClientId: "",
		reqClientSecret: "",
		reqScope: "",
		reqType: "noAuth",
	},
	reqBody: {
		reqData: "",
		reqType: "none",
		reqFormat: "json",
	},
	reqHeaders: [],
	reqParams: [],
};

export const INIT_RESPONSE_DATA = {
	reqBody: {
		reqData: "",
		reqType: "raw",
		reqFormat: "json",
	},
	reqHeaders: [],
};

export const REQ_URLS = {
	addCollectionUrl: `api-collection`,
	updateCollectionUrl: `api-collection`,
	deleteCollectionUrl: `api-collection`,
	folderUrl: `api-folder-detail`,
	folderAllUrl: `api-collection`,
	addFolderUrl: `folder`,
	updateFolderUrl: `folder`,
	deleteFolderUrl: `folder`,
	duplicateFolderUrl: `duplicate-folder`,

	fileUrl: `api-engine-details`,
	fileAllUrl: `api-folder-file`,
	addFileUrl: `api-request`,
	updateFileUrl: `api-request`,
	deleteFileUrl: `api-request`,
	duplicateFileUrl: `api-request`,

	getExampleUrl: `api-example`,
	addExampleUrl: `api-example`,
	updateExampleUrl: `api-example`,
	deleteExampleUrl: `api-example`,
	duplicateExampleUrl: `api-example`,

	environments: "appenvs",

	getHistories: `apihistory`,
	deleteHistory: `apihistory`,
	deleteHistoryDate: `apihistory-delete-date`,
	updateHistory: `apihistory`,
};

export const COLLECTION_TREE_ITEM_TYPES = {
	COLLECTION: "COLLECTION",
	FOLDER: "FOLDER",
	REQUEST: "REQUEST",
	MOCK_REQUEST: "MOCK_REQUEST",
	EXAMPLE: "EXAMPLE",
	TEST_SUITE: "TEST_SUITE",
	TEST_FOLDER: "TEST_FOLDER",
	TEST_CASE: "TEST_CASE",
};

export const MOCK_TREE_ITEM_TYPES = {
	MOCK: "MOCK",
	MOCK_REQUEST: "MOCK_REQUEST",
};

export const TYPE_SIDEBAR = {
	COLLECTION: "collection",
	API: "api",
	ENVIRONMENT: "environment",
	MOCK: "mock",
	MONITOR: "monitor",
	FLOW: "flow",
	HISTORY: "history",
	HOSTING: "hosting",
	DEPENDENCIES: "dependencies",
	DOCUMENTATION: "documentation",
	GOVERNANCE: "governance",
	PROJECTS: "projects",
	API_STUDIO: "apiStudio",
};

export const baseLabelI18n = "requestLeftSidebar.";

export const ACTION_TREE_ITEM_MENUS = {
	ADD_REQUEST: {
		label: `${baseLabelI18n}actionMenu.addRequest`,
		key: "addRequest",
	},
	ADD_FOLDER: {
		label: `${baseLabelI18n}actionMenu.addFolder`,
		key: "addFolder",
	},
	ADD_EXAMPLE: {
		label: `${baseLabelI18n}actionMenu.addExample`,
		key: "addExample",
	},
	RENAME: {
		label: `${baseLabelI18n}actionMenu.rename`,
		key: "rename",
	},
	DELETE: {
		label: `${baseLabelI18n}actionMenu.delete`,
		key: "delete",
	},
	EDIT: {
		label: `${baseLabelI18n}actionMenu.edit`,
		key: "edit",
	},
	RUN_FOLDER: {
		label: `${baseLabelI18n}actionMenu.runFolder`,
		key: "runFolder",
	},
	RUN_COLLECTION: {
		label: `${baseLabelI18n}actionMenu.runCollection`,
		key: "runCollection",
	},
	SHARE_COLLECTION: {
		label: `${baseLabelI18n}actionMenu.shareCollection`,
		key: "shareCollection",
	},
	DUPLICATE: {
		label: `${baseLabelI18n}actionMenu.duplicate`,
		key: "duplicate",
	},
	SAVE_REQUEST: {
		label: `${baseLabelI18n}actionMenu.saveRequest`,
		key: "saveRequest",
	},
	MONITOR_REQUEST: {
		label: `${baseLabelI18n}actionMenu.monitorRequest`,
		key: "monitorRequest",
	},
	DOCUMENT_REQUEST: {
		label: `${baseLabelI18n}actionMenu.documentRequest`,
		key: "documentRequest",
	},
	ADD_MOCK_API: {
		label: `${baseLabelI18n}actionMenu.addMockApi`,
		key: "addMockApi",
	},
	SHARE: {
		label: `${baseLabelI18n}actionMenu.share`,
		key: "share",
	},
	MOVE: {
		label: `${baseLabelI18n}actionMenu.move`,
		key: "move",
	},
	CREATE_FORK: {
		label: `${baseLabelI18n}actionMenu.createFork`,
		key: "createFork",
	},
	CREATE_PULL_RQ: {
		label: `${baseLabelI18n}actionMenu.createPullRq`,
		key: "createPullRq",
	},
	MERGE_CHANGES: {
		label: `${baseLabelI18n}actionMenu.mergeChanges`,
		key: "mergeChanges",
	},
	PULL_CHANGES: {
		label: `${baseLabelI18n}actionMenu.pullChanges`,
		key: "pullChanges",
	},
	MANAGE_ROLES: {
		label: `${baseLabelI18n}actionMenu.manageRoles`,
		key: "manageRoles",
	},
	EXPORT: {
		label: `${baseLabelI18n}actionMenu.export`,
		key: "export",
	},
	ADD_TEST_CASE: {
		label: `${baseLabelI18n}actionMenu.AddTestCase`,
		key: "addTestCase",
	},
};

export const MENUS_TREE_ITEM = {
	COLLECTION: {
		COLLECTION_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_FOLDER,
			ACTION_TREE_ITEM_MENUS.ADD_REQUEST,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.EXPORT,
			ACTION_TREE_ITEM_MENUS.DELETE,
			ACTION_TREE_ITEM_MENUS.RUN_COLLECTION,
			ACTION_TREE_ITEM_MENUS.SHARE_COLLECTION,
		],
		FOLDER_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_FOLDER,
			ACTION_TREE_ITEM_MENUS.ADD_REQUEST,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
			// ACTION_TREE_ITEM_MENUS.RUN_FOLDER,
		],
		REQUEST_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_EXAMPLE,
			ACTION_TREE_ITEM_MENUS.DUPLICATE,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
		EXAMPLE_ITEM: [
			ACTION_TREE_ITEM_MENUS.DUPLICATE,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
		API_STUDIO_FOLDER_ITEM: [ACTION_TREE_ITEM_MENUS.DELETE],
		API_STUDIO_ITEM: [ACTION_TREE_ITEM_MENUS.DELETE],
		CAPABILITIES_FOLDER_ITEM: [ACTION_TREE_ITEM_MENUS.EDIT, ACTION_TREE_ITEM_MENUS.DELETE],
		FEATURES_FOLDER_ITEM: [ACTION_TREE_ITEM_MENUS.EDIT, ACTION_TREE_ITEM_MENUS.DELETE],
		TEST_CASE_FOLDER_ITEM: [ACTION_TREE_ITEM_MENUS.EDIT, ACTION_TREE_ITEM_MENUS.DELETE],
		TEST_SUITE_FOLDER_ITEM: [ACTION_TREE_ITEM_MENUS.EDIT, ACTION_TREE_ITEM_MENUS.DELETE],
	},
	HISTORY: {
		COLLECTION_ITEM: [ACTION_TREE_ITEM_MENUS.DELETE],
		REQUEST_ITEM: [ACTION_TREE_ITEM_MENUS.DELETE],
	},
	API: {},
	ENVIRONMENT: {
		COLLECTION_ITEM: [
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DUPLICATE,
			ACTION_TREE_ITEM_MENUS.EXPORT,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
	},
	PROJECTS: {
		COLLECTION_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_FOLDER,
			ACTION_TREE_ITEM_MENUS.ADD_TEST_CASE,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.EXPORT,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
		TEST_FOLDER_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_FOLDER,
			ACTION_TREE_ITEM_MENUS.ADD_TEST_CASE,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
		TEST_CASE_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_EXAMPLE,
			ACTION_TREE_ITEM_MENUS.DUPLICATE,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
		EXAMPLE_ITEM: [
			ACTION_TREE_ITEM_MENUS.DUPLICATE,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
	},
	MOCK: {
		MOCK_ITEM: [
			ACTION_TREE_ITEM_MENUS.ADD_MOCK_API,
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
		MOCK_REQUEST_ITEM: [
			ACTION_TREE_ITEM_MENUS.RENAME,
			ACTION_TREE_ITEM_MENUS.EDIT,
			ACTION_TREE_ITEM_MENUS.DELETE,
		],
	},
	MONITOR: {},
	FLOW: {},
	HOSTING: {},
	DEPENDENCIES: {},
	DOCUMENTATION: {},
	GOVERNANCE: {},
	API_STUDIO: [ACTION_TREE_ITEM_MENUS.ADD_FOLDER, ACTION_TREE_ITEM_MENUS.DELETE],
};

export const MORE_ACTIONS = {
	ADD_WATCH_LIST: "ADD_WATCH_LIST",
	ADD_RQ_TO_COLLECTION: "ADD_RQ_TO_COLLECTION",
	DELETE_RQ: "DELETE_RQ",
	SET_ACTIVE_ENV: "SET_ACTIVE_ENV",
};

export const MORE_ACTIONS_ITEM = {
	COLLECTION: {
		COLLECTION_ITEM: [MORE_ACTIONS.ADD_WATCH_LIST],
	},
	HISTORY: {
		COLLECTION_ITEM: [],
		REQUEST_ITEM: [],
	},
	API: {},
	ENVIRONMENT: {
		COLLECTION_ITEM: [MORE_ACTIONS.SET_ACTIVE_ENV],
	},
	MOCK: {},
	MONITOR: {},
	FLOW: {},
	HOSTING: {},
	DEPENDENCIES: {},
	DOCUMENTATION: {},
	GOVERNANCE: {},
};

export const RoleCode = {
	TEAM_MEMBER: "TEAM_MEMBER",
	TEAM_ADMIN: "TEAM_ADMIN",
	VIEWER: "VIEWER",
	COMPANY_ADMIN: "COMPANY_ADMIN",
};
// please do not remove the type declaration, it's used for type checking
export const PermissionVariable: { [key: string]: string } = {
	//Company Info permissions
	COMPANY_INFORMATION_SIDEBAR: "COMPANY_INFORMATION",
	COMPANY_INFORMATION_CREATE: "COMPANY_INFORMATION",
	COMPANY_INFORMATION_VIEW: "COMPANY_INFORMATION",
	COMPANY_INFORMATION_UPDATE: "COMPANY_INFORMATION",
	COMPANY_INFORMATION_DELETE: "COMPANY_INFORMATION",

	DEPARTMENTS_SIDEBAR: "DEPARTMENTS",
	DEPARTMENTS_CREATE: "DEPARTMENTS",
	DEPARTMENTS_VIEW: "DEPARTMENTS",
	DEPARTMENTS_UPDATE: "DEPARTMENTS",
	DEPARTMENTS_DELETE: "DEPARTMENTS",

	TEAMS_SIDEBAR: "TEAMS",
	TEAMS_CREATE: "TEAMS",
	TEAMS_VIEW: "TEAMS",
	TEAMS_UPDATE: "TEAMS",
	TEAMS_DELETE: "TEAMS",

	//Users permissions
	USERS_SIDEBAR: "USERS",
	USERS_CREATE: "USERS",
	USERS_VIEW: "USERS",
	USERS_UPDATE: "USERS",
	USERS_DELETE: "USERS",

	//role based auth permissions
	ROLE_BASED_AUTH_SIDEBAR: "ROLE_BASED_AUTH",
	ROLE_BASED_AUTH_CREATE: "ROLE_BASED_AUTH",
	ROLE_BASED_AUTH_VIEW: "ROLE_BASED_AUTH",
	ROLE_BASED_AUTH_UPDATE: "ROLE_BASED_AUTH",
	ROLE_BASED_AUTH_DELETE: "ROLE_BASED_AUTH",

	//Business Applications permissions
	BUSINESS_APPLICATIONS_SIDEBAR: "BUSINESS_APPLICATIONS",
	BUSINESS_APPLICATIONS_CREATE: "BUSINESS_APPLICATIONS",
	BUSINESS_APPLICATIONS_VIEW: "BUSINESS_APPLICATIONS",
	BUSINESS_APPLICATIONS_UPDATE: "BUSINESS_APPLICATIONS",
	BUSINESS_APPLICATIONS_DELETE: "BUSINESS_APPLICATIONS",

	//Env Topology permissions
	ENV_TOPOLOGY_SIDEBAR: "ENV_TOPOLOGY",
	ENV_TOPOLOGY_CREATE: "ENV_TOPOLOGY",
	ENV_TOPOLOGY_VIEW: "ENV_TOPOLOGY",
	ENV_TOPOLOGY_UPDATE: "ENV_TOPOLOGY",
	ENV_TOPOLOGY_DELETE: "ENV_TOPOLOGY",

	//Integration permissions
	INTEGRATION_SIDEBAR: "INTEGRATION",
	INTEGRATION_CREATE: "INTEGRATION",
	INTEGRATION_VIEW: "INTEGRATION",
	INTEGRATION_UPDATE: "INTEGRATION",
	INTEGRATION_DELETE: "INTEGRATION",
	INTEGRATION_CONFIGURE: "INTEGRATION",
	INTEGRATION_TEST: "INTEGRATION",

	//API Info permissions
	API_INFO_SIDEBAR: "API_INFO",
	API_INFO_CREATE: "API_INFO",
	API_INFO_VIEW: "API_INFO",
	API_INFO_UPDATE: "API_INFO",
	API_INFO_DELETE: "API_INFO",
};

export const frequencyType = [
	{ label: "Minutes", value: "MINUTES" },
	{ label: "Hours", value: "HOURS" },
	{ label: "Weeks", value: "WEEKS" },
];

export const frequencyMinute = Array.from({ length: 51 }, (_, i) => ({
	label: `${i + 10} Minute${i + 10 > 1 ? "s" : ""}`,
	value: `${(i + 10).toString()}+${uuid()}`,
}));

export const frequencyHour = Array.from({ length: 24 }, (_, i) => ({
	label: `${i + 1} Hour${i + 1 > 1 ? "s" : ""}`,
	value: `${(i + 1).toString()}+${uuid()}`,
}));

export const frequencyTime = Array.from({ length: 24 }, (_, i) => ({
	label: `${i.toString().padStart(2, "0")}:00`,
	value: `${i.toString().padStart(2, "0")}:00+${uuid()}`,
}));

export const frequencyWeek = [
	{ label: "Sunday", value: "SUNDAY" },
	{ label: "Monday", value: "MONDAY" },
	{ label: "Tuesday", value: "TUESDAY" },
	{ label: "Wednesday", value: "WEDNESDAY" },
	{ label: "Thursday", value: "THURSDAY" },
	{ label: "Friday", value: "FRIDAY" },
	{ label: "Saturday", value: "SATURDAY" },
];

export const frequencyWeekDelivary = [
	{ label: "Sunday", value: "SUNDAY" },
	{ label: "Monday", value: "MONDAY" },
	{ label: "Tuesday", value: "TUESDAY" },
	{ label: "Wednesday", value: "WEDNESDAY" },
	{ label: "Thursday", value: "THURSDAY" },
	{ label: "Friday", value: "FRIDAY" },
	{ label: "Saturday", value: "SATURDAY" },
];

export const notificationVia = [
	{ label: "Email", value: "EMAIL" },
	{ label: "SMS", value: "SMS" },
	{ label: "Slack", value: "SLACK" },
	{ label: "Teams", value: "TEAMS" },
];

export const notificationAfter = [
	{ label: "0-10", value: "0-10" },
	{ label: "11-20", value: "11-20" },
	{ label: "21-30", value: "21-30" },
	{ label: "31-40", value: "31-40" },
	{ label: "41-50", value: "41-50" },
];

export const MATCH_VAR = {
	start: "{",
	end: "}",
};

export const HttpStatusCodes = {
	"100": "Continue",
	"101": "Switching Protocols",
	"102": "Processing",
	"103": "Early Hints",
	"200": "OK",
	"201": "Created",
	"202": "Accepted",
	"203": "Non-Authoritative Information",
	"204": "No Content",
	"205": "Reset Content",
	"206": "Partial Content",
	"207": "Multi-Status",
	"208": "Already Reported",
	"300": "Multiple Choices",
	"301": "Moved Permanently",
	"302": "Found",
	"303": "See Other",
	"304": "Not Modified",
	"305": "Use Proxy",
	"307": "Temporary Redirect",
	"308": "Permanent Redirect",
	"400": "Bad Request",
	"401": "Unauthorized",
	"402": "Payment Required",
	"403": "Forbidden",
	"404": "Not Found",
	"405": "Method Not Allowed",
	"406": "Not Acceptable",
	"407": "Proxy Authentication Required",
	"408": "Request Timeout",
	"409": "Conflict",
	"410": "Gone",
	"411": "Length Required",
	"412": "Precondition Failed",
	"413": "Payload Too Large",
	"414": "URI Too Long",
	"415": "Unsupported Media Type",
	"416": "Range Not Satisfiable",
	"417": "Expectation Failed",
	"418": "I'm a teapot",
	"421": "Misdirected Request",
	"422": "Unprocessable Entity",
	"423": "Locked",
	"424": "Failed Dependency",
	"425": "Too Early",
	"426": "Upgrade Required",
	"428": "Precondition Required",
	"429": "Too Many Requests",
	"431": "Request Header Fields Too Large",
	"451": "Unavailable For Legal Reasons",
	"500": "Internal Server Error",
	"501": "Not Implemented",
	"502": "Bad Gateway",
	"503": "Service Unavailable",
	"504": "Gateway Timeout",
	"505": "HTTP Version Not Supported",
	"506": "Variant Also Negotiates",
	"507": "Insufficient Storage",
	"508": "Loop Detected",
	"510": "Not Extended",
	"511": "Network Authentication Required",
};

export const REQ_INFO_AUTH_SELECT_VALUE = {
	NO_AUTH: "noAuth",
	AUTH2: "auth2",
	API_KEY: "apiKey",
	BEARER_TOKEN: "bearerToken",
	BASIC_AUTH: "basicAuth",
};

export const ITEM_TYPE = {
	COLLECTION: "COLLECTION",
	HISTORY: "HISTORY",
	ENVIRONMENT: "ENVIRONMENT",
	MOCK: "MOCK",
	SHARED: "SHARED",
};

export const MULTI_LANGUAGE = {
	ENG: "en",
	HIN: "hi",
	VIT: "vi",
	ESP: "es",
	ARB: "ar",
} as const;

export const MULTI_LANGUAGE_NAMES = {
	en: "English",
	hi: "Hindi",
	vi: "Vietnamese",
	es: "Espanish",
	ar: "Arabic",
} as const;

export const COMPANY_INFORMATION_PATH = "/company-settings/settings/company-information";
export const ORGANIZATION_PATH = "/company-settings/settings/organization";
export const ORGANIZATION_CREATE_PATH = "/company-settings/settings/organization/create";
export const ORGANIZATION_UPDATE_PATH = "/company-settings/settings/organization/update/:id";
export const DEPARTMENT_PATH = "/company-settings/settings/department";
export const DEPARTMENT_CREATE_PATH = "/company-settings/settings/department/create";
export const DEPARTMENT_UPDATE_PATH = "/company-settings/settings/department/update/:id";
export const TEAMS_PATH = "/company-settings/settings/teams";
export const TEAMS_CREATE_PATH = "/company-settings/settings/team/create";
export const TEAMS_DETAILS_PATH = "/company-settings/settings/team/detail/:id";
export const USERS_PATH = "/company-settings/settings/users";
export const USERS_CREATE_PATH = "/company-settings/settings/users/create";
export const USERS_UPDATE_PATH = "/company-settings/settings/users/update/:id";
export const ROLE_BASED_AUTH_ROLE_PATH = "/company-settings/settings/roles";
export const ROLE_BASED_AUTH_ROLE_CREATE_PATH = "/company-settings/settings/role/create";
export const ROLE_BASED_AUTH_ROLE_DETAILS_PATH = "/company-settings/settings/role/detail/:roleCode";
export const ROLE_BASED_AUTH_SCREEN_CREATE_PATH = "/company-settings/settings/screen/create";
export const ROLE_BASED_AUTH_SCREEN_DETAILS_PATH =
	"/company-settings/settings/screen/detail/:screenCode";
export const ADD_SCREEN_ROLE_MAPPING_PATH =
	"/company-settings/settings/screen/add-screen-role-mapping/create";
export const UPDATE_SCREEN_ROLE_MAPPING_PATH =
	"/company-settings/settings/screen/add-screen-role-mapping/:id";
export const ROLE_BASED_AUTH_CONFIGURE_SCREEN_CREATE_PATH =
	"/company-settings/settings/screens/configure-screen";
export const ROLE_BASED_AUTH_CONFIGURE_SCREEN_UPDATE_PATH =
	"/company-settings/settings/screens/configure-screen/:screenCode";
export const BUSINESS_APPLICATIONS_PATH = "/company-settings/settings/projects";
export const BUSINESS_APPLICATIONS_CREATE_PATH = "/company-settings/settings/project/create";
export const BUSINESS_APPLICATIONS_DETAILS_PATH =
	"/company-settings/settings/project/details/:workSpaceId";
export const ENV_TOPOLOGY_PATH = "/company-settings/settings/environment-topology";
export const ENV_TOPOLOGY_DETAILS_PATH = "/company-settings/settings/environment-topology/:id";
export const INTEGRATION_PATH = "/company-settings/settings/integration";
export const INTEGRATION_CREATE_JIRA_PATH = "/company-settings/settings/integration/create-jira";
export const INTEGRATION_ADD_JIRA_USER = "/company-settings/settings/integration/add-user";
export const INTEGRATION_UPDATE_JIRA_USER = "/company-settings/settings/integration/update-user";
export const APPEARANCE_PATH = "/company-settings/settings/appearance";
export const PERSONALLY_IDENTIFIABLE_INFORMATION =
	"/company-settings/settings/personally-identifiable-information";

export const APPEARANCE_DETAILS_PATH = "/company-settings/settings/appearance/:id";
export const APPEARANCE_CREATE_PATH = "/company-settings/settings/appearance/create";
export const API_INFO_PATH = "/company-settings/api-info";

export const API_CATEGORIZATION_PATH = "/company-settings/settings/api-categorization";


// matching route support
export const ROLE_BASED_AUTH_ROLE_DETAILS_PATH_MATCHING = "/company-settings/settings/role/detail";
export const TEAMS_DETAILS_PATH_MATCHING = "/company-settings/settings/team/detail";
export const BUSINESS_APPLICATIONS_DETAILS_PATH_MATCHING =
	"/company-settings/settings/project/details";
export const ROLE_BASED_AUTH_SCREEN_DETAILS_PATH_MATCHING =
	"/company-settings/settings/screen/detail";
export const UPDATE_SCREEN_ROLE_MAPPING_PATH_MATCHING =
	"/company-settings/settings/screen/add-screen-role-mapping";

export const priority = [
	{ label: "Low", value: "LOW", color: "lightgreen" },
	{ label: "Medium", value: "MEDIUM", color: "yellow" },
	{ label: "High", value: "HIGH", color: "orange" },
	{ label: "Critical", value: "CRITICAL", color: "red" },
];
